import { http } from "../client";
export var createTimetable = function (data) {
    return http.api
        .post("timetables", data)
        .then(function (response) { return response.data.data; })
        .then(function (_a) {
        var id = _a.id, title = _a.title, user_id = _a.user_id;
        return ({ id: id, title: title, userId: user_id });
    });
};
